import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatAmount',
  standalone: true
})
export class FormatAmountPipe implements PipeTransform {

  transform(value: number): string {

    const options1 = {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    };

    const options2 = {
      minimumFractionDigits: 1,
      maximumFractionDigits: 2
    };

    if (value === Math.floor(value)) {
      // whole
      return new Intl.NumberFormat('en-US', options1).format(value);
    } else {
      // non-whole
      return new Intl.NumberFormat('en-US', options2).format(value);
    }
  }

}
